import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "공유로 수익 얻기",
  cinema_referralDesc: "개인 링크로 친구를 초대하고 보상을 받으세요",
  cinema_referralLinkTitle: "내 추천 링크",
  cinema_referralLinkDesc: "이 링크를 통해 새로 가입한 회원은 모두 귀하에게 기록됩니다",
  cinema_referralRulesTitle: "추천 규정",
  cinema_referralRulesCoins: "친구가 귀하의 추천 링크를 통해 가입하면 코인 보상을 받을 수 있습니다. 코인은 플랫폼에서 콘텐츠 시청에만 사용 가능하며, 현금으로 교환하거나 출금할 수 없습니다.",
  cinema_referralRulesCommission: "친구가 충전하면 해당 규정에 따라 수수료를 받을 수 있습니다. 출금이 가능한 것은 충전 수수료뿐이며, 금액이 ¥100에 도달하면 USDT 출금을 요청하실 수 있습니다.",
  cinema_copyLink: "링크 복사",
  cinema_inviteCodeLabel: "추천 코드",
  cinema_inviteRuleTitle: "추천 보상",
  cinema_inviteRuleNormal: "회원은 성공적으로 가입한 각 회원당 20코인을 받습니다. 보상은 코인 내역에 기록됩니다.",
  cinema_distributorOverview: "디스트리뷰터 개요",
  cinema_availableCommission: "이용 가능",
  cinema_totalCommission: "총 수수료",
  cinema_pendingWithdrawal: "출금 대기 중",
  cinema_withdrawnAmount: "출금 완료",
  cinema_firstLevelRate: "레벨 1 비율",
  cinema_secondLevelRate: "레벨 2 비율",
  cinema_todayBrowse: "조회 수",
  cinema_todayRegister: "가입 수",
  cinema_todayRecharge: "충전 수",
  cinema_todayRechargeAmount: "충전 금액",
  cinema_commissionAmount: "수수료",
  cinema_registerDetails: "가입 수",
  cinema_rechargeDetails: "충전 수",
  cinema_inviteRewards: "추천 보상",
  cinema_goWithdraw: "출금",
  cinema_noReferralData: "아직 추천 데이터가 없습니다",
  cinema_referralLoadFailed: "추천 데이터를 불러올 수 없습니다. 다시 시도해 주세요.",
  cinema_loginToPromote: "로그인하여 추천 링크를 생성하세요",
  cinema_totalEarnings: "총 수익",
  cinema_withdrawable: "출금 가능",
  cinema_frozen: "동결됨",
  cinema_invitedCount: "초대됨",
  cinema_coinUnit: "코인",
  cinema_people: "명",
  cinema_conversionStats: "추천 전환율",
  cinema_allDatesTotal: "모든 날짜 합계",
  cinema_selectedDatesTotal: "선택한 날짜 합계",
  cinema_conversionStatsDesc: "일별 조회 수, 가입 수, 충전 수 및 수수료",
  cinema_colDate: "날짜",
  cinema_colPv: "방문자 수",
  cinema_colBrowseCount: "조회 수",
  cinema_colRegister: "가입자 수",
  cinema_colRechargeUsers: "결제자 수",
  cinema_colRechargeOrders: "주문 건수",
  cinema_colPaidAmount: "결제 금액",
  cinema_colCommission: "수수료",
  cinema_colRegisterRate: "가입률",
  cinema_colRechargeRate: "재충전률",
  cinema_commissionRateTitle: "수수료율",
  cinema_currentRateLabel: "현재 실제 수수료율",
  cinema_baseRate: "기본 수수료율",
  cinema_currentRate: "현재 수수료율",
  cinema_earningsRecord: "수익 기록",
  cinema_inviteDetail: "초대 내역",
  cinema_allEarnings: "전체 수익",
  cinema_filterAll: "전체",
  cinema_filterPending: "보류 중",
  cinema_filterSettled: "정산됨",
  cinema_earningsDate: "날짜",
  cinema_earningsType: "유형",
  cinema_earningsUser: "사용자",
  cinema_earningsAmount: "수익",
  cinema_earningsStatus: "상태",
  cinema_statusSettled: "정산됨",
  cinema_statusPending: "보류 중",
  cinema_noEarningsRecords: "아직 기록이 없습니다",
  cinema_referralUser: "사용자",
  cinema_referralRegDate: "가입일",
  cinema_referralRecharged: "총 재충전 금액",
  cinema_referralEarned: "나의 수익",
  cinema_startDate: "시작일",
  cinema_endDate: "종료일",
  cinema_query: "검색",
  cinema_dateRangeError: "시작일은 종료일보다 늦을 수 없습니다",
  cinema_brand: "Huangguo TV",
  cinema_language: "언어",
  cinema_tagline: "AI 오리지널 숏드라마",
  cinema_navHome: "홈",
  cinema_navCategories: "랭킹",
  cinema_rankingTitle: "랭킹",
  cinema_rankingAll: "전체",
  cinema_rankingLoading: "랭킹 로딩 중...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}}개의 시리즈 · {{views}}회 시청",
  cinema_rankingTotal: "전체 기간",
  cinema_rankingMonth: "월간",
  cinema_rankingWeek: "주간",
  cinema_rankingLatest: "최신",
  cinema_rankingCreator: "크리에이터",
  cinema_creatorLabel: "크리에이터",
  cinema_rankingEmpty: "아직 랭크된 시리즈가 없습니다",
  cinema_navMyList: "인기",
  cinema_soundGuideTitle: "여기를 탭해 사운드를 켜세요",
  cinema_soundGuideAction: "사운드 켜기",
  cinema_soundGuideDismiss: "사운드 안내 닫기",
  cinema_navHistory: "기록",
  cinema_navAds: "코인",
  cinema_adsTitle: "추천 광고",
  cinema_adsSubtitle: "더 많은 추천 콘텐츠를 발견하세요",
  cinema_adFeatured: "추천",
  cinema_adOpen: "지금 보기",
  cinema_adsEmpty: "이용 가능한 광고가 없습니다",
  cinema_adsLoadFailed: "광고를 불러올 수 없습니다. 다시 시도해 주세요.",
  cinema_earnTitle: "코인 적립",
  cinema_earnSubtitle: "매일 체크인하고 코인을 모으세요",
  cinema_earnBalance: "내 코인",
  cinema_checkInTitle: "매일 체크인",
  cinema_checkInSubtitle: "연속 기록을 유지하면 더 많은 코인을 얻을 수 있습니다",
  cinema_checkInDay: "오늘 {{day}}일째",
  cinema_checkInToday: "오늘",
  cinema_checkInClaim: "{{points}}코인을 받으려면 체크인하세요",
  cinema_checkInClaimed: "오늘 체크인했습니다",
  cinema_checkInLogin: "체크인하려면 로그인하세요",
  cinema_checkInSuccess: "체크인 완료. {{points}}코인을 적립하셨습니다",
  cinema_checkInFailed: "체크인에 실패했습니다. 인터넷 연결을 확인한 후 다시 시도해 주세요",
  cinema_checkInNoReward: "이 기기는 오늘의 체크인 보상을 이미 받았습니다",
  cinema_checkInStreak: "현재 연속 기록",
  cinema_checkInStreakValue: "{{days}}일",
  cinema_checkInTotal: "총 적립 금액",
  cinema_checkInTotalValue: "{{points}} 코인",
  cinema_checkInLoadFailed: "출석체크 상태를 불러오지 못했습니다",
  cinema_retry: "다시 시도해 보세요",
  cinema_moreEarnWays: "더 많은 적립 방법",
  cinema_inviteEarnTitle: "친구를 초대하고 적립하세요",
  cinema_inviteEarnDesc: "친구가 가입하면 코인을 받으세요",
  cinema_goInvite: "초대하기",
  cinema_earnCoinsTitle: "코인 적립",
  cinema_earnCoinsBalance: "내 코인",
  cinema_earnCoinsSignInStreak: "{{count}}일 동안 출석체크하셨습니다",
  cinema_earnCoinsCheckIn: "출석체크",
  cinema_earnCoinsCheckedIn: "출석체크 완료",
  cinema_earnCoinsTomorrow: "내일 다시 오세요",
  cinema_earnCoinsInviteTitle: "친구를 초대하면 적립 가능",
  cinema_earnCoinsInviteCode: "내 초대 코드",
  cinema_earnCoinsGoInvite: "지금 초대하기",
  cinema_earnCoinsLimitedTask: "제한된 미션",
  cinema_earnCoinsTimeLeft: "카운트다운",
  cinema_earnCoinsNewbieTask: "초보자 미션",
  cinema_earnCoinsDailyTask: "일일 미션",
  cinema_earnCoinsRecommendations: "추천",
  cinema_earnCoinsAdTask: "광고 보기",
  cinema_earnCoinsAdTaskDesc: "광고를 시청하면 더 많은 코인을 적립할 수 있습니다",
  cinema_earnCoinsGoWatch: "광고 시청",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "{{day}}일차",
  cinema_earnCoinsToday: "오늘",
  cinema_earnCoinsCoinUnit: "코인",
  cinema_earnCoinsAdCurrent: "현재 미션",
  cinema_earnCoinsAdLocked: "잠긴 미션",
  cinema_earnCoinsTaskCompleted: "완료됨",
  cinema_limitedRechargeTaskTitle: "첫 번째 충전을 1시간 이내에 완료하세요",
  cinema_limitedRechargeTaskAction: "충전하기",
  cinema_claimReward: "신청하기",
  cinema_claiming: "신청 중",
  cinema_taskClaimFailed: "신청에 실패했습니다. 다시 시도해 주세요.",
  cinema_bindEmailAction: "이메일 연동",
  cinema_limitedRechargeTaskExpired: "만료됨",
  cinema_watchHistory: "시청 기록",
  cinema_navSearch: "시리즈 검색...",
  cinema_login: "로그인",
  cinema_vip: "충전",
  cinema_heroPlay: "지금 재생",
  cinema_heroMore: "더 알아보기",
  cinema_hotRecommend: "현재 인기",
  cinema_carouselLoading: "추천 콘텐츠 로딩 중...",
  cinema_newRelease: "신작 출시",
  cinema_allSeries: "전체 시리즈",
  cinema_viewAll: "모두 보기",
  cinema_episodes: "{{count}}편",
  cinema_rating: "{{score}}점 평점",
  cinema_views: "{{count}}회 시청",
  cinema_play: "재생",
  cinema_continueWatch: "계속 시청",
  cinema_rewatch: "다시 보기",
  cinema_categoryAll: "전체",
  cinema_categoryUrban: "도시 로맨스",
  cinema_categorySuspense: "서스펜스",
  cinema_categoryCostume: "역사",
  cinema_categoryWorkplace: "직장",
  cinema_categorySciFi: "공상과학",
  cinema_categorySciFiRomance: "공상과학 로맨스",
  cinema_unlock: "에피소드 잠금 해제",
  cinema_unlockDesc: "이 에피소드를 잠금 해제하려면 {{cost}}코인이 필요합니다",
  cinema_unlockConfirm: "확인 및 재생",
  cinema_cancel: "취소",
  cinema_balance: "잔액: {{coins}}코인",
  cinema_insufficient: "코인이 부족합니다. 충전해 주세요",
  cinema_unlocked: "잠금 해제됨",
  cinema_locked: "잠금 상태",
  cinema_episodeNumber: "에피소드 {{number}}",
  cinema_playing: "현재 재생 중",
  cinema_backToList: "목록으로 돌아가기",
  cinema_back: "뒤로",
  cinema_noSeries: "이용 가능한 시리즈가 없습니다",
  cinema_seriesDesc: "줄거리",
  cinema_episodeList: "에피소드",
  cinema_nextEpisode: "다음",
  cinema_episodeEnded: "에피소드 종료",
  cinema_nextEpisodePrompt: "에피소드 {{number}}로 계속하시겠습니까?",
  cinema_playNextEpisode: "다음 에피소드 재생",
  cinema_prevEpisode: "이전",
  cinema_freeLabel: "무료",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "신규",
  cinema_hotLabel: "인기",
  cinema_featuredBanner: "이번 주 필수 시청",
  cinema_watchNow: "지금 보기",
  cinema_searchPlaceholder: "작품 검색",
  cinema_noResults: "찾은 시리즈 없음",
  cinema_emptyMyList: "아직 내 목록에 시리즈가 없습니다",
  cinema_emptyHistory: "시청 기록이 없습니다",
  cinema_addToMyList: "내 목록에 추가",
  cinema_removeFromMyList: "내 목록에서 제거",
  cinema_clearAll: "모두 지우기",
  cinema_footerCopy: "황궈 TV — 프리미엄 단편 드라마 플랫폼",
  cinema_footerWarning: "콘텐츠는 오락을 위해 AI가 생성한 것입니다. 현지 법규를 준수해 주시기 바랍니다.",
  cinema_myList: "내 목록",
  cinema_addedAt: "{{date}} 추가",
  cinema_expand: "확장",
  cinema_collapse: "축소",
  cinema_historyAll: "전체",
  cinema_historyUnfinished: "미완성",
  cinema_historyFinished: "완료",
  cinema_historyCount: "{{count}}건의 기록",
  cinema_noHistoryFilter: "해당 카테고리에 기록이 없습니다",
  cinema_finished: "완료",
  cinema_watchedFull: "완성",
  cinema_welcomeBack: "다시 오신 것을 환영합니다",
  cinema_loginDesc: "로그인하여 더 많은 콘텐츠를 잠금 해제하세요",
  cinema_phoneLogin: "휴대폰 로그인",
  cinema_emailLogin: "이메일 로그인",
  cinema_phonePlaceholder: "휴대폰 번호 입력",
  cinema_emailPlaceholder: "이메일 주소 입력",
  cinema_agreeTerms: "로그인함으로써 다음 사항에 동의합니다",
  cinema_userAgreement: "이용약관",
  cinema_privacyPolicy: "개인정보처리방침",
  cinema_getCode: "코드 받기",
  cinema_loginNow: "지금 로그인",
  cinema_otherLogin: "기타 로그인 방법",
  cinema_loggingIn: "로그인 중...",
  cinema_loginSuccess: "로그인 성공",
  cinema_loginRedirect: "프로필로 리디렉션 중...",
  cinema_profile: "프로필",
  cinema_memberLabel: "회원",
  cinema_dealerLabel: "총판",
  cinema_coinAmount: "{{count}} 코인",
  cinema_profileAccount: "계정",
  cinema_profileContent: "콘텐츠",
  cinema_profileSettings: "설정",
  cinema_editProfile: "프로필 편집",
  cinema_myCoins: "내 코인",
  cinema_myPurchases: "구매 내역",
  cinema_downloads: "다운로드",
  cinema_playbackSettings: "재생 설정",
  cinema_notifications: "알림",
  cinema_cacheManage: "캐시 관리",
  cinema_about: "문의하기",
  cinema_contactUnavailable: "고객 서비스가 이용 불가능합니다. 나중에 다시 시도해 주세요.",
  cinema_watchedHours: "시청 시간",
  cinema_collectionCount: "컬렉션",
  cinema_logout: "로그아웃",
  cinema_logoutConfirm: "로그아웃을 확인하시겠습니까?",
  cinema_logoutConfirmDesc: "모든 기능을 사용하려면 다시 로그인해야 합니다",
  cinema_version: "버전 {{version}}",
  cinema_rechargeTitle: "충전",
  cinema_rechargeSubtitle: "충전 플랜 선택",
  cinema_rechargeVpnWarning: "VPN 또는 프록시는 결제 위험 제어를 활성화하여 결제 페이지가 열리지 않거나 결제가 실패할 수 있습니다.",
  cinema_rechargeVpnGuideTitle: "결제 전에 VPN을 비활성화해 주세요",
  cinema_rechargeVpnInstruction: "VPN을 비활성화한 후, 아래 버튼을 클릭하여 선택하신 결제 방법으로 계속 진행해 주세요.",
  cinema_rechargeVpnContinue: "VPN이 꺼졌습니다. 결제를 계속 진행합니다",
  cinema_rechargeRMB: "RMB 충전",
  cinema_rechargeUSDT: "USDT 충전",
  cinema_rechargeRecommended: "추천",
  cinema_rechargeCoins: "코인",
  cinema_rechargeBonus: "+{{points}} 보너스",
  cinema_rechargeCredited: "{{points}} 받기",
  cinema_firstRechargeBannerTitle: "첫 충전 보너스! 금액에 상관없이 추가 보상",
  cinema_firstRechargeSelectedBonus: "+{{points}} 코인",
  cinema_firstRechargeLimitedTitle: "한정된 첫 충전 보너스",
  cinema_dailyRechargeLimitedTitle: "한정된 충전 보너스",
  cinema_firstRechargeLimitedBonus: "금액에 상관없이 추가 {{percent}}% 보너스",
  cinema_rechargePayMethod: "결제 방법",
  cinema_rechargePay: "결제하기",
  cinema_rechargeNoPackages: "현재 이용 가능한 충전 플랜이 없습니다",
  cinema_paymentUnavailable: "현재 결제가 불가능합니다. 지원팀에 문의해 주세요.",
  cinema_follow: "팔로우",
  cinema_collect: "수집",
  cinema_share: "공유",
  cinema_loading: "로드 중...",
  cinema_favorites: "즐겨찾기",
  cinema_emptyFavorites: "아직 즐겨찾는 시리즈가 없습니다",
  cinema_emptyPurchases: "아직 구매한 시리즈가 없습니다",
  cinema_clearAllConfirm: "시청 기록을 모두 삭제하시겠습니까?",
  cinema_episodesUnit: "에피소드",
  cinema_lastWatched: "마지막으로 시청한 에피소드 {{episode}}",
  cinema_purchasedEpisodes: "{{count}}개의 에피소드 잠금 해제됨",
  cinema_account: "계정",
  cinema_accountName: "표시 이름",
  cinema_accountEmail: "이메일",
  cinema_shareCode: "공유 코드",
  cinema_saveProfile: "프로필 저장",
  cinema_profileSaved: "프로필이 저장되었습니다",
  cinema_profileSaveFailed: "프로필 저장에 실패했습니다",
  cinema_accountInfo: "기본 정보",
  cinema_changePassword: "비밀번호 변경",
  cinema_newPassword: "새 비밀번호",
  cinema_confirmPassword: "새 비밀번호 확인",
  cinema_passwordHint: "최소 6자 이상 사용하세요",
  cinema_passwordMismatch: "두 비밀번호가 일치하지 않습니다",
  cinema_passwordSaved: "비밀번호가 업데이트되었습니다",
  cinema_passwordSaveFailed: "비밀번호 업데이트에 실패했습니다",
  cinema_savePassword: "비밀번호 저장",
  cinema_pointsBalance: "코인 잔액",
  cinema_coinLedger: "코인 내역",
  cinema_businessReference: "참고",
  cinema_emptyPointLogs: "아직 코인 내역이 없습니다",
  cinema_pointLog_registerReward: "가입 보상",
  cinema_pointLog_appFirstLoginReward: "앱 첫 로그인 보상",
  cinema_pointLog_inviteReward: "초대 보상",
  cinema_pointLog_dailyCheckIn: "매일 출석 보상",
  cinema_pointLog_limitedRechargeTask: "제한된 첫 충전 미션 보상",
  cinema_pointLog_emailBindingTask: "이메일 연동 미션 보상",
  cinema_pointLog_dailyUnlockTask: "매일 에피소드 잠금 해제 미션 보상",
  cinema_bindEmailTaskTitle: "이메일 연결",
  cinema_dailyUnlockTaskTitle: "새 에피소드 {{count}}개 잠금 해제",
  cinema_unlockAction: "잠금 해제",
  cinema_dailyTaskProgress: "오늘 진행률 {{current}}/{{target}} (1화 제외)",
  cinema_pointLog_firstEpisodeUnlock: "첫 번째 에피소드 패스 잠금 해제",
  cinema_pointLog_episodeUnlock: "에피소드 잠금 해제",
  cinema_pointLog_recharge: "충전 적립 완료",
  cinema_pointLog_firstRechargeBonus: "첫 충전 보너스",
  cinema_pointLog_dailyRechargeBonus: "한정 충전 보너스",
  cinema_pointLog_adminAdjust: "관리자 조정",
  cinema_pointLog_other: "코인 변경",
  cinema_pointBiz_register: "가입",
  cinema_pointBiz_registerBackfill: "가입 보상 재충전",
  cinema_pointBiz_appFirstLogin: "최초 앱 로그인",
  cinema_pointBiz_inviteRegister: "초대 가입",
  cinema_pointBiz_dailyCheckIn: "일일 체크인",
  cinema_pointBiz_legacyLimitedRechargeTask: "24시간 충전 미션",
  cinema_pointBiz_limitedRechargeTask: "1시간 첫 충전 미션",
  cinema_pointBiz_emailBindingTask: "이메일 연동 미션",
  cinema_pointBiz_unlockThreeEpisodes: "일일 에피소드 3개 잠금 해제 미션",
  cinema_pointBiz_unlockFiveEpisodes: "일일 에피소드 5개 잠금 해제 미션",
  cinema_pointBiz_episodeUnlock: "에피소드 잠금 해제",
  cinema_pointBiz_rechargeOrder: "충전 주문",
  cinema_pointBiz_adminAdjust: "관리자 조정",
  cinema_pointBiz_other: "기타 업무",
  cinema_playbackAutoplay: "다음 에피소드 자동 재생",
  cinema_playbackAutoplayDesc: "에피소드 종료 시 자동으로 계속 재생",
  cinema_aboutDesc: "나의 판타지는 지속적으로 업데이트되는 단편 드라마 콘텐츠를 제공합니다.",
  cinema_rechargeOrders: "충전 내역",
  cinema_myRechargeRecords: "나의 충전 기록 보기",
  cinema_totalInvites: "총 초대 수",
  cinema_distributionStats: "프로모션 통계",
  cinema_distributionStatsDesc: "날짜별 조회, 가입, 충전 및 수수료 확인",
  cinema_summaryDate: "날짜",
  cinema_summaryBrowse: "조회 수",
  cinema_summaryRegister: "가입 수",
  cinema_summaryRechargeCount: "충전 수",
  cinema_conversionRate: "전환율",
  cinema_commissionRatio: "수수료 비율",
  cinema_browseDetails: "상세 정보 보기",
  cinema_browseTime: "조회 시간",
  cinema_browseDrama: "드라마",
  cinema_browseRegion: "지역",
  cinema_noBrowseData: "아직 조회 기록이 없습니다",
  cinema_noSummaryData: "아직 요약 데이터가 없습니다",
  cinema_rewarded: "보상됨",
  cinema_registered: "등록됨",
  cinema_close: "닫기",
  cinema_emptyRechargeOrders: "아직 충전 기록이 없습니다",
  cinema_rechargeRecords: "충전 내역",
  cinema_commissionRecords: "수수료 내역",
  cinema_rechargeTime: "충전 시간",
  cinema_paymentMethod: "결제 수단",
  cinema_paymentStatus: "결제 상태",
  cinema_orderNo: "주문 번호",
  cinema_noRechargeRecords: "아직 충전 기록이 없습니다",
  cinema_commissionTime: "수수료 발생 시간",
  cinema_commissionLevel: "수수료 등급",
  cinema_commissionRate: "수수료 비율",
  cinema_noCommissionRecords: "아직 수수료 기록이 없습니다",
  cinema_search: "검색",
  cinema_reset: "초기화",
  cinema_previousPage: "이전",
  cinema_nextPage: "다음",
  cinema_paymentStatus_created: "생성됨",
  cinema_paymentStatus_pending: "결제 대기 중",
  cinema_paymentStatus_paid: "충전 완료",
  cinema_paymentStatus_failed: "결제 실패",
  cinema_paymentStatus_closed: "종료됨",
  cinema_paymentStatus_expired: "만료됨",
  cinema_paymentAwaiting: "주문이 생성되었습니다. 결제 페이지에서 결제를 완료해 주세요. 결제에 실패할 경우, VPN이 꺼져 있는지 확인해 주시기 바랍니다.",
  cinema_usdtAddress: "수신 주소",
  cinema_usdtNetwork: "TRC20 네트워크 전용",
  cinema_copy: "복사",
  cinema_copied: "복사 완료",
  cinema_playerSettings: "재생 설정",
  cinema_playerQuality: "품질",
  cinema_playerSpeed: "재생 속도",
  cinema_playerAuto: "자동",
  cinema_playerSource: "원본",
  cinema_playerSubtitles: "자막",
  cinema_subtitleAuto: "자동 자막",
  cinema_subtitleOff: "자막 끄기",
  cinema_appDownloadTitle: "앱에서 다음 에피소드를 더 안정적으로 시청하세요",
  cinema_appDownloadDesc: "진행 상황을 기억하고 업데이트 알림을 받으세요.",
  cinema_appDownloadReward: "앱을 다운로드하고 첫 로그인 시 {{points}} 보너스 코인을 받아보세요!",
  cinema_homeAppDownloadReward: "앱으로 로그인하면 {{points}} 보너스 코인을 받으실 수 있습니다!",
  cinema_shareEarnPoints: "공유하고 벌기",
  cinema_shareLinkLabel: "링크 공유",
  cinema_shareRewardUnlimited: "귀하의 링크를 통해 가입하는 신규 사용자 한 명당 {{points}} 코인을 무제한으로 획득하세요!",
  cinema_loginForShareLink: "로그인하여 나만의 공유 링크를 확인하세요",
  cinema_viewReferralStats: "추천 통계 보기",
  cinema_episodeFinished: "에피소드 완료",
  cinema_unlockNextEpisode: "다음 에피소드 잠금 해제",
  cinema_changeDrama: "동영상 변경",
  cinema_allUnlocked: "모두 잠금 해제됨",
  cinema_appDownloadButton: "앱 다운로드",
  cinema_appDownloadUnavailable: "아직 다운로드가 제공되지 않습니다",
  cinema_rechargeAppPromptTitle: "보너스 코인을 받으려면 앱을 다운로드하세요",
  cinema_rechargeAppPromptReward: "다운로드 후 로그인하면 {{points}} 추가 코인을 받으실 수 있습니다!",
  cinema_rechargeAppPromptDesc: "앱에서 더욱 안정적인 재생과 자동 시청 진행 기록을 즐겨보세요.",
  cinema_appDownloadQr: "스캔하여 앱을 다운로드하세요",
  cinema_ageGateBadge: "연령 인증",
  cinema_ageGateTitle: "성인 콘텐츠 안내",
  cinema_ageGateDescription: "본 웹사이트는 성인 전용의 가상 AI 생성 콘텐츠를 포함하고 있습니다. 계속하시면 귀하가 만 18세 이상임을 확인하며, 귀하의 거주지 법률을 준수하기로 동의하시는 것입니다.",
  cinema_ageGateUnderage: "만 18세 미만이시라면 지금 이 웹사이트를 떠나 주시기 바랍니다.",
  cinema_ageGateConfirm: "저는 만 18세 이상입니다 — 웹사이트 입장",
  cinema_creatorCenter: "크리에이터 센터",
  cinema_creatorCenterDesc: "당신의 이야기를 창작하고, 당신의 세상을 공유하세요",
  cinema_creatorCenterNote: "참고: 비원본 작품에는 워터마크가 없어야 합니다",
  cinema_creatorMemberReady: "VIP 회원이신 경우, 원클릭으로 신청하세요",
  cinema_creatorBecome: "크리에이터 되기",
  cinema_creatorGateDesc: "당신의 이야기를 황궈 TV에 선보이세요. 승인되면 귀하의 작품은 영화관에서 수백만 시청자가 감상할 수 있으며, 탁월한 재능을 인정받아 프리미엄 구독 수익 배분을 받으실 수 있습니다.",
  cinema_creatorApplyBtn: "크리에이터 신청하기",
  cinema_creatorBenefitTitle: "크리에이터 혜택",
  cinema_creatorBenefit1: "귀하의 작품에 ‘오리지널’ 전용 태그를 부여받으세요",
  cinema_creatorBenefit2: "조회수, 구독자 수, 수익 배분을 실시간으로 확인하세요",
  cinema_creatorBenefit3: "더 많은 제작 도구와 홍보 자원을 이용하실 수 있습니다",
  cinema_creatorReviewTip: "신청 및 작품은 플랫폼에서 검토되며, 커뮤니티 가이드라인을 준수해야 합니다.",
  cinema_creatorLevel: "검증된 크리에이터",
  cinema_creatorOriginal: "오리지널",
  cinema_creatorSince: "크리에이터 시작 연도",
  cinema_creatorAddWork: "새로운 작품 업로드",
  cinema_creatorTabOverview: "개요",
  cinema_creatorTabWorks: "내 작품",
  cinema_creatorTabUpload: "업로드",
  cinema_creatorTabPlatform: "스튜디오",
  cinema_creatorSubmitted: "제출됨, 검토 대기 중",
  cinema_creatorStatViews: "총 조회수",
  cinema_creatorStatSubs: "총 구독자 수",
  cinema_creatorStatRevenue: "총 수익",
  cinema_creatorStatWithdraw: "인출 가능",
  cinema_creatorStatWorks: "작품",
  cinema_creatorStatReview: "검토 중",
  cinema_creatorStatRejected: "거절됨",
  cinema_creatorTopWork: "가장 성과가 좋은 작품",
  cinema_creatorViews: "조회수",
  cinema_creatorSubscriptions: "구독자 수",
  cinema_creatorShare: "수익",
  cinema_creatorNoPublished: "아직 게시된 작품이 없습니다",
  cinema_creatorFilterPublished: "게시됨",
  cinema_creatorFilterReview: "검토 중",
  cinema_creatorFilterRejected: "거절됨",
  cinema_creatorWorksTitle: "내 작품",
  cinema_creatorNoWorks: "아직 작품이 없으니 첫 번째 작품을 업로드해 주세요",
  cinema_creatorGoUpload: "지금 업로드",
  cinema_creatorStatusPublished: "게시됨",
  cinema_creatorStatusReview: "검토 중",
  cinema_creatorStatusApproved: "트랜스코딩 대기 중",
  cinema_creatorStatusTranscoding: "트랜스코딩 중",
  cinema_creatorStatusReady: "게시 대기 중",
  cinema_creatorStatusTranscodeFailed: "트랜스코딩 실패",
  cinema_creatorStatusPublishFailed: "게시 실패",
  cinema_creatorStatusRejected: "거절됨",
  cinema_creatorPublishedOn: "게시일",
  cinema_creatorSubmittedOn: "제출일",
  cinema_creatorRejectedTip: "거절 · 제출일",
  cinema_creatorWorkName: "작품 제목",
  cinema_creatorWorkNamePh: "작품 제목을 입력하세요",
  cinema_creatorCategory: "카테고리",
  cinema_creatorCover: "표지",
  cinema_creatorCoverHint: "세로형 표지 이미지 하나를 업로드하세요",
  cinema_creatorCoverUrlPh: "이미지 링크를 붙여넣으세요(선택 사항)",
  cinema_creatorSynopsis: "줄거리",
  cinema_creatorSynopsisPh: "한두 문장으로 당신의 이야기를 설명해 주세요…",
  cinema_creatorEpisodeTitle: "에피소드",
  cinema_creatorEpisodeDesc: "각 에피소드에 제목을 추가하고 MP4 또는 MOV 영상을 하나씩 업로드하세요",
  cinema_creatorEpisodeTitlePh: "에피소드 제목",
  cinema_creatorEpisodeDurPh: "지속 시간(분)",
  cinema_creatorAddEpisode: "에피소드 추가",
  cinema_creatorEpShort: "에피소드 {{count}}",
  cinema_creatorEpisodeUpload: "영상 업로드",
  cinema_creatorEpisodeUploading: "업로드 중…",
  cinema_creatorEpisodeReplace: "동영상 교체",
  cinema_creatorEpisodeMp4Only: ".mp4, .mov 파일을 지원하며, 파일당 최대 100MB까지",
  cinema_creatorEpisodeTypeError: "모든 에피소드는 .mp4 또는 .mov 형식의 영상이어야 합니다",
  cinema_creatorEpisodeSizeError: "각 에피소드 영상의 크기는 100MB 이하여야 합니다",
  cinema_creatorEpisodeUploadFailed: "에피소드 업로드에 실패했습니다. 다시 시도해 주세요.",
  cinema_creatorEpisodeRequired: "각 에피소드에 제목을 붙이고 MP4 또는 MOV 영상을 업로드하세요",
  cinema_creatorRequired: "먼저 제목을 입력하고 표지를 선택해 주세요",
  cinema_creatorWorkNameRequired: "작품 제목을 입력하세요",
  cinema_creatorCategoryRequired: "카테고리를 선택하세요",
  cinema_creatorCoverRequired: "표지 이미지를 업로드하세요",
  cinema_creatorEpisodeTitleRequired: "에피소드 제목을 입력하세요",
  cinema_creatorEpisodeVideoRequired: "해당 에피소드의 MP4 또는 MOV 영상을 업로드하세요",
  cinema_creatorSubmit: "검토 제출",
  cinema_creatorPlatformTag: "크리에이터 추천",
  cinema_creatorPlatformTitle: "창작 도구 플랫폼",
  cinema_creatorPlatformDesc: "전문 도구, 대본 아이디어 및 자산을 제공하는 공식 창작 플랫폼으로 이동하여 당신의 이야기를 현실로 만들어 출판해 보세요.",
  cinema_creatorPlatformPoint1: "AI 대본 및 아이디어",
  cinema_creatorPlatformPoint2: "전문 창작 및 업로드 도구",
  cinema_creatorPlatformPoint3: "트래픽 지원 및 수익 배분",
  cinema_creatorPlatformOpen: "창작 플랫폼으로 이동하기",
  cinema_creatorEarnBannerTitle: "당신의 이야기를 영화관으로 가져오기",
  cinema_creatorEarnBannerDesc: "크리에이터가 되어 작품을 업로드하고 조회수, 구독자 수, 수익 분배로 수익을 얻으세요",
  cinema_creatorEarnBannerBtn: "크리에이터 센터 열기",
  cinema_creatorApplyFailed: "신청에 실패했습니다. 다시 시도해 주세요.",
  cinema_creatorSubmitFailed: "제출에 실패했습니다. 다시 시도해 주세요.",
  cinema_creatorSubmitting: "제출 중…",
  cinema_creatorCategoryEmpty: "사용 가능한 카테고리가 없습니다",
  cinema_creatorCoverUpload: "표지 업로드",
  cinema_creatorCoverUploading: "업로드 중…",
  cinema_creatorCoverChoose: "이미지 선택",
  cinema_creatorCoverReplace: "이미지 교체",
  cinema_creatorCoverRemove: "제거",
  cinema_creatorCoverFormat: "JPG, PNG, WebP 또는 GIF 형식으로 최대 10MB까지. 이미지 한 장만 가능합니다.",
  cinema_creatorCoverTypeError: "JPG, PNG, WebP 또는 GIF 이미지를 선택하세요",
  cinema_creatorCoverSizeError: "표지 이미지는 최대 10MB 이하여야 합니다",
  cinema_creatorCoverUploadFailed: "표지 업로드에 실패했습니다. 다시 시도해 주세요.",
  cinema_creatorUploadNoticeTitle: "업로드 가이드라인",
  cinema_creatorUploadNotice1: "업로드된 모든 자료는 원본이든 변형이든 워터마크가 없어야 합니다.",
  cinema_creatorUploadNotice2: "원작자는 당사 비즈니스 팀에 연락하여 저작권 소유권을 등록하실 수 있습니다.",
  cinema_creatorUploadNotice3: "최종 에피소드 가격은 플랫폼에서 결정됩니다.",
  cinema_creatorUploadNotice4: "각 에피소드의 길이는 최소 150초 이상이어야 합니다.",
  cinema_creatorUploadNoticeConfirm: "이해했습니다, 계속하기",
  cinema_navProfile: "마이",
};
